var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { LangDropdown } from './langDropdown';
// import { Locale, LanguageHelper } from '../../helpers/languageHelper';
// import { SnippetHelper }  from '../../helpers/snippetHelper';
import { LanguageHelper } from '@pm-tt/common-components/lib/LanguageHelper';
import { SnippetHelper } from '@pm-tt/common-components/lib/SnippetHelper';
var UtilityNav = /** @class */ (function (_super) {
    __extends(UtilityNav, _super);
    function UtilityNav(props) {
        var _this = _super.call(this, props) || this;
        _this.currentLanguage = "English";
        _this._isMounted = false;
        _this.handleClick = function (event) {
            // console.log("we clicked");
            var myElement = _this.parentRef;
            // console.log("myElement:");
            // console.log(myElement);
            if (myElement.contains(event.target)) {
                // console.log("clicked inside");
                // the click is inside so continue to whatever we were doing before
                return;
            }
            if (_this.state.utilityNavDropdownOpen || _this.state.langDropdownOpen) {
                // the click is outside, do something
                // console.log("clicked outside");
                _this.dropdownButtonClick(event, "all");
            }
        };
        _this.BackButtonClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            // back button was clicked; slide the panel back to the right and close the language dropdown
            // console.log("BackButtonClick");
            _this.slidePanel("right");
            // then close it
            _this.setState({
                sliderOpen: false,
                langDropdownOpen: false,
                utilityNavDropdownIndex: null,
                utilityNavDropdownOpen: false
            }, function () {
                // tell the parent (Header) to change tabindexes on the previous panel
                // 1 = change tab indexes on the first panel
                // false = the first panel is no longer hidden
                _this.props.tabIndexCallback(1, false, "utilityLanguageButton");
            });
        };
        _this.dropdownButtonClick = function (e, type, id) {
            e.preventDefault();
            e.stopPropagation();
            if (_this.state.isTablet) {
                // console.log("utility nav is in mobile state")
                if (_this.state.sliderOpen) {
                    _this.slidePanel("right");
                    if (type == "lang") {
                        // it's open, slide right to close it
                        // console.log("language is open, close it");
                        // then close it
                        _this.setState({
                            sliderOpen: false,
                            langDropdownOpen: false
                        }, function () {
                            // tell the parent (Header) to change tabindexes on the previous panel
                            // 1 = change tab indexes on the first panel
                            // false = the first panel is no longer hidden
                            // TODO: What's the right thing here?
                            _this.props.tabIndexCallback(1, false, "utilityLanguageButton");
                        });
                    }
                    else if (type == "nav") {
                        // it's open, slide right to close it
                        // then close it
                        _this.setState({
                            sliderOpen: false,
                            utilityNavDropdownOpen: false,
                            utilityNavDropdownIndex: null
                        }, function () {
                            // tell the parent (Header) to change tabindexes on the previous panel
                            // 1 = change tab indexes on the first panel
                            // false = the first panel is no longer hidden
                            _this.props.tabIndexCallback(1, false, "utilityLanguageButton");
                        });
                    }
                }
                else {
                    if (type == "lang") {
                        // it's closed, open it
                        console.log("language is closed, open it");
                        _this.setState({
                            sliderOpen: true,
                            langDropdownOpen: true,
                            utilityNavDropdownOpen: false,
                            utilityNavDropdownIndex: null
                        }, function () {
                            // then slide left
                            _this.slidePanel("left");
                            // tell the parent (Header) to change tabindexes on the previous panel
                            // 1 = change tab indexes on the first panel
                            // true = the first panel is hidden
                            _this.props.tabIndexCallback(1, true, "utilityLanguageButton");
                        });
                    }
                    else if (type == "nav") {
                        _this.setState({
                            sliderOpen: true,
                            utilityNavDropdownOpen: true,
                            utilityNavDropdownIndex: id,
                            langDropdownOpen: false
                        }, function () {
                            // then slide left
                            _this.slidePanel("left");
                            // tell the parent (Header) to change tabindexes on the previous panel
                            // 1 = change tab indexes on the first panel
                            // true = the first panel is hidden
                            _this.props.tabIndexCallback(1, true, "utilityLanguageButton");
                        });
                    }
                }
            }
            else {
                // console.log("utility nav is in desktop state");
                if (type == "lang") {
                    _this.setState({
                        langDropdownOpen: !_this.state.langDropdownOpen,
                        utilityNavDropdownIndex: null,
                        utilityNavDropdownOpen: false
                    }, function () {
                        // keep body from scrolling
                        document.getElementById("s4-workspace").classList.toggle("noScroll");
                    });
                }
                else if (type = "nav") {
                    // if already open, but index has changed
                    if (_this.state.utilityNavDropdownOpen && _this.state.utilityNavDropdownIndex != id) {
                        _this.setState({
                            utilityNavDropdownIndex: id,
                            utilityNavDropdownOpen: true,
                            langDropdownOpen: false
                        });
                    }
                    else {
                        // console.log(id);
                        _this.setState({
                            utilityNavDropdownOpen: !_this.state.utilityNavDropdownOpen,
                            utilityNavDropdownIndex: _this.state.utilityNavDropdownIndex != null ? null : id,
                            langDropdownOpen: false
                        }, function () {
                            // keep body from scrolling
                            document.getElementById("s4-workspace").classList.toggle("noScroll");
                        });
                    }
                }
                else if (type = "all") {
                    _this.setState({
                        langDropdownOpen: false,
                        utilityNavDropdownIndex: null,
                        utilityNavDropdownOpen: false
                    }, function () {
                        // keep body from scrolling
                        document.getElementById("s4-workspace").classList.toggle("noScroll");
                    });
                }
            }
        };
        _this.slidePanel = function (dir) {
            // sets the style="left: xx" position on the #mobileNav container element to push it to the right or left (or reset to zero).
            // console.log("direction slide:" + dir);
            var panel = document.getElementById("mobileNavContainer");
            var panelWidth = this.props.componentWidth;
            var newPosition = 0;
            var currentPosition = panel.style.left.length ? panel.style.left : "0";
            // console.log("currentPosition: " + currentPosition);
            if (dir == "left") {
                newPosition = parseInt(currentPosition) - panelWidth;
            }
            else if (dir == "right") {
                newPosition = parseInt(currentPosition) + panelWidth;
            }
            else { // reset
                newPosition = 0;
            }
            // console.log("newPosition: " + newPosition);
            panel.style.left = newPosition + "px";
        };
        _this.state = {
            utilityLanguage: "",
            utilityLoginLink: "",
            utilityLoginText: "",
            utilityLoginTab: "",
            utilityNavLinks: [],
            utilityNavDropdownOpen: false,
            utilityNavDropdownIndex: null,
            langDropdownOpen: false,
            sliderOpen: false,
            isTablet: _this.props.isTablet ? _this.props.isTablet : undefined,
            componentWidth: _this.props.componentWidth ? _this.props.componentWidth : undefined,
            componentHeight: _this.props.componentHeight ? _this.props.componentHeight : undefined
        };
        _this.onComponentResize = _this.onComponentResize.bind(_this);
        return _this;
    }
    UtilityNav.prototype.onComponentResize = function () {
        // console.log("UtilityNav.tsx onComponentResize()", this.props);
        var tabletBreakpoint = 1219; // new max for larger menu 991; // max
        var smallerThanTabletBreakpoint = document.documentElement.clientWidth <= tabletBreakpoint ? true : false;
        this.setState({
            isTablet: this.props.isTablet ? this.props.isTablet : smallerThanTabletBreakpoint,
            componentWidth: this.props.componentWidth ? this.props.componentWidth : document.getElementById("s4-bodyContainer").clientWidth,
            componentHeight: this.props.componentHeight ? this.props.componentHeight : document.getElementById("s4-workspace").clientHeight
        });
    };
    UtilityNav.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentLocale, delayResizeEvent;
            var _this = this;
            return __generator(this, function (_a) {
                this._isMounted = true;
                SnippetHelper.getSnippet("#utilityLanguage").then(function (snippet) {
                    // set snippet to state
                    if (snippet.length > 0 && _this._isMounted) {
                        _this.setState({
                            utilityLanguage: snippet[0].snippet
                        });
                    }
                });
                SnippetHelper.getSnippet("#utilityLogin").then(function (snippet) {
                    // set snippet to state
                    if (snippet.length > 0 && _this._isMounted) {
                        _this.setState({
                            utilityLoginLink: snippet[0].url.url,
                            utilityLoginText: snippet[0].url.description,
                            utilityLoginTab: snippet[0].openNew ? "_blank" : ""
                        });
                    }
                });
                SnippetHelper.getSnippet("#utilityNav").then(function (snippets) { return __awaiter(_this, void 0, void 0, function () {
                    var utilityNav;
                    var _this = this;
                    return __generator(this, function (_a) {
                        utilityNav = [];
                        if (snippets.length > 0 && this._isMounted) {
                            snippets.map(function (snippet) { return __awaiter(_this, void 0, void 0, function () {
                                var listItems, navLinks, listItem;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            listItems = [];
                                            return [4 /*yield*/, SnippetHelper.getSnippet(snippet.snippet)];
                                        case 1:
                                            navLinks = _a.sent();
                                            // console.log("navLinks", navLinks);
                                            if (navLinks.length > 0) {
                                                navLinks.map(function (navLink) {
                                                    listItems.push({
                                                        title: navLink.url.description,
                                                        url: navLink.url.url,
                                                        openNew: navLink.openNew
                                                    });
                                                });
                                            }
                                            listItem = {
                                                title: snippet.url.description ? snippet.url.description : "",
                                                url: snippet.url.url ? snippet.url.url : "",
                                                openNew: snippet.openNew,
                                                items: listItems
                                            };
                                            // console.log("listItem",listItem);
                                            utilityNav.push(listItem);
                                            // console.log("utilityNav inside", utilityNav);
                                            this.setState({
                                                utilityNavLinks: utilityNav
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            // console.log("utilityNav", utilityNav);
                            this.setState({
                                utilityNavLinks: utilityNav
                            });
                        }
                        return [2 /*return*/];
                    });
                }); });
                currentLocale = LanguageHelper.getCurrentLocale();
                // console.log(currentLocale);
                if (currentLocale.Locale == "es-es") {
                    this.currentLanguage = "Español";
                }
                else if (currentLocale.Locale == "pt-pt") {
                    this.currentLanguage = "Português";
                }
                else if (currentLocale.Locale == "fr-fr") {
                    this.currentLanguage = "Français";
                }
                else if (currentLocale.Locale == "de-de") {
                    this.currentLanguage = "Deutsch";
                }
                else if (currentLocale.Locale == "nl-nl") {
                    this.currentLanguage = "Dutch";
                }
                if (!this.props.isTablet) {
                    document.addEventListener('click', this.handleClick, false);
                }
                window.addEventListener('resize', function () {
                    _this.onComponentResize();
                });
                // we call onComponentResize() initially when the component first loads, after waiting a few seconds for the rest of the page to load
                (function () { return _this.onComponentResize(); });
                return [2 /*return*/];
            });
        });
    };
    UtilityNav.prototype.componentWillUnmount = function () {
        var _this = this;
        // remove the resize listener when this component is unmounted
        window.removeEventListener('resize', function () {
            _this.onComponentResize();
        });
        this._isMounted = false;
        if (!this.props.isTablet) {
            document.removeEventListener('click', this.handleClick, false);
        }
    };
    UtilityNav.prototype.render = function () {
        var _this = this;
        if (this.props.isTablet) {
            // if mobile nav, we have to set the width and height of the mobile nav dropdown
            this.mobileNavPanelStyle = {
                width: this.props.componentWidth + 'px',
                height: this.props.componentHeight + 'px',
                left: this.props.componentWidth + 'px'
            };
        }
        else {
            this.mobileNavPanelStyle = {};
        }
        return (React.createElement("ul", { id: "utilityNav", ref: function (el) { return _this.parentRef = el; } },
            this.state.utilityNavLinks.length > 0 && this.state.utilityNavLinks.map(function (topLevelItem, i, arr) { return (React.createElement("li", { key: i }, topLevelItem.items.length > 0 ? (React.createElement(React.Fragment, null,
                React.createElement("button", { className: "hasChildren", onKeyDown: function (e) { return _this.processKeyPress(i, arr, e, null); }, tabIndex: _this.state.sliderOpen && _this.state.utilityNavDropdownOpen ? -1 : 0, id: "utilityNav" + i, onClick: function (e) { return _this.dropdownButtonClick(e, "nav", "utilityNav" + i); } }, topLevelItem.title),
                _this.state.utilityNavDropdownOpen && _this.state.utilityNavDropdownIndex == "utilityNav" + i && (React.createElement("div", { className: "utilityNavDropdown", style: _this.mobileNavPanelStyle, ref: function (el) { return _this.parentRef = el; } },
                    React.createElement("ul", null,
                        _this.state.isTablet && (React.createElement("li", null,
                            React.createElement("button", { tabIndex: 0, ref: function (el) { return _this.backButtonRef = el; }, className: "dropdownBack", onKeyDown: function (e) { return _this.processKeyPress(-1, null, e, "utilityNav" + i); }, onClick: function (e) { return _this.dropdownButtonClick(e, "nav", "utilityNav" + i); } }, "Back"))),
                        topLevelItem.items.map(function (subLevelItem, j, subArr) { return (React.createElement("li", { key: "utilSub" + j },
                            React.createElement("a", { href: subLevelItem.url, target: subLevelItem.openNew ? "_blank" : "_self", onKeyDown: function (e) { return _this.processKeyPress(j, subArr, e, "utilityNav" + i); } }, subLevelItem.title))); })))))) : (React.createElement("a", { href: topLevelItem.url, target: topLevelItem.openNew ? "_blank" : "_self" }, topLevelItem.title)))
            // <li id="utilityContactUs"><a onKeyDown={(e) => this.processKeyPress( !this.state.utilityTermsLink.length && !this.state.utilityLoginLink.length && !this.state.utilityLanguage.length,e)} tabIndex={ this.state.sliderOpen ? -1 : 0} href={this.state.utilityContactUsLink}>{this.state.utilityContactUsText}</a></li>
            ); }),
            this.state.utilityLoginLink.length > 0 && this.state.utilityLoginText.length > 0 && (React.createElement("li", null,
                React.createElement("a", { target: this.state.utilityLoginTab, tabIndex: this.state.sliderOpen ? -1 : 0, href: this.state.utilityLoginLink },
                    React.createElement("span", { id: "utilityLogin" }, this.state.utilityLoginText)))),
            this.state.utilityLanguage.length > 0 && (React.createElement("li", { className: "utilitySeparator" },
                React.createElement("button", { onKeyDown: function (e) { return _this.processKeyPress(-2, null, e, null); }, tabIndex: this.state.sliderOpen && this.state.langDropdownOpen ? -1 : 0, id: "utilityLanguageButton", onClick: function (e) { return _this.dropdownButtonClick(e, "lang"); } },
                    React.createElement("span", { id: "utilityLanguage" }, this.currentLanguage),
                    " ",
                    React.createElement("span", { id: "utilityChange" }, this.state.utilityLanguage)),
                this.state.langDropdownOpen && (React.createElement(LangDropdown, { clickBackCallback: function (e) { return _this.BackButtonClick(e); }, isTablet: this.state.isTablet, componentHeight: this.state.componentHeight, componentWidth: this.state.componentWidth, clickOutsideCallback: function (e) { return _this.dropdownButtonClick(e, "lang"); } }))))));
    }; // end render()
    // // @last: if true, this is the last link
    // private processKeyPress(last: boolean, e): void {
    //     if( last && e.keyCode==9 && !e.shiftKey && this.state.isTablet && !this.state.langDropdownOpen){
    //             let meganavFocusLink = document.querySelectorAll("#meganav BUTTON, #meganav A")[0] as HTMLElement;
    //         if( meganavFocusLink){
    //             meganavFocusLink.focus();
    //             e.preventDefault();
    //         }
    //     }
    // }
    /**
     *
     * @param i if -1, back button. if -1, language button. otherwise pass in index
     * @param arr pass in map array
     * @param e
     * @param parent parent's ID - where the focus should be if closing
     */
    UtilityNav.prototype.processKeyPress = function (i, arr, e, parent) {
        console.log("arr", arr, "i=", i, "parent=", parent);
        // if back button
        if (i === -1) {
            if (this.props.isTablet) {
                // we want to go back to the search button if in mobile
                if (e.keyCode == 9 && e.shiftKey) {
                    // console.log("backwards");
                    document.getElementById(parent).focus();
                    e.preventDefault();
                }
            }
        }
        if (i === -2) {
            // language button
            if (this.props.isTablet) {
                // going forward without opening language dropdown
                if (e.keyCode == 9 && !e.shiftKey && !this.state.langDropdownOpen) {
                    console.log(e.keyCode, e.shiftKey);
                    var parentFocus = document.querySelector("#meganav li:first-child button");
                    parentFocus.focus();
                    e.preventDefault();
                }
            }
        }
        if (arr) {
            // if first item in desktop, backwards tab closes the dropdown
            if (i === 0) {
                if (e.keyCode == 9 && e.shiftKey && !this.props.isTablet) {
                    // focus back on parent
                    var parentFocus = document.getElementById(parent);
                    parentFocus.focus();
                    e.preventDefault();
                    // this.props.clickOutsideCallback(e);
                    this.dropdownButtonClick(e, "all");
                }
            }
            // if last item
            if (i === arr.length - 1) {
                if (e.keyCode == 9 && !e.shiftKey) {
                    if (this.props.isTablet) {
                        // we want to return to the top of the #langdropdown element in mobile
                        this.backButtonRef.focus();
                        e.preventDefault();
                    }
                    else {
                        // we want the dropdown to close when you tab past in desktop
                        // this.props.clickOutsideCallback(e);
                        this.dropdownButtonClick(e, "all");
                    }
                }
            }
        }
    };
    return UtilityNav;
}(React.Component));
export { UtilityNav };
